let plusRegistration = [
  {
    path: '/plus_registration_login',
    name: '登记',
    component: () => import('@/pages/plusRegistration/plus_registration_login')
  },
  {
    path: '/plus_registration_detail',
    name: '登记',
    component: () => import('@/pages/plusRegistration/plus_registration_detail')
  },
  {
    path: '/plus_registration_list',
    name: '登记记录',
    component: () => import('@/pages/plusRegistration/plus_registration_list')
  },
  {
    path: '/plus_doctor_detail',
    // name: '登记记录',
    component: () => import('@/pages/plusRegistration/plus_doctor_detail')
  }
]
export default plusRegistration
